
const template = require('./statsList.template');

/**
 * @ngdoc directive
 * @name sharebase.myAccount.pxStatsList
 * @restrict E
 * @description
 *
 * A simple component that displays an array of user stat objects.
 *
 * @useage
 *
 * <px-stats-list stats="vm.stats"></px-stats-list>
 */
export function StatsListDirective(): ng.IDirective {
    return {
        restrict: 'E',
        controller: StatsListController,
        controllerAs: 'vm',
        bindToController: true,
        template,
        scope: {
            stats: '<'
        }
    }
}

/**
 * Describes the shape of the user stats objects that the @see sharebase.myAccount.pxStatsList
 * directive expects.
 */
export type UserStat = {
    label: string;
    count: number;
    useItemSize?: boolean;
}

/**
 * A helper function that converts an server stats object to an object
 * that implements @see UserStat.
 *
 * @param stat The server side stat object
 * @returns A @see UserStat object that mirrors the given server side object.
 */
export const srvStatToClientStat = (stat: any): UserStat => ({ label: stat.Label, count: stat.Count });

export class StatsListController {
    public stats: UserStat[] = [];
}


// WEBPACK FOOTER //
// ./src/sharebase/components/myAccount/statsList/statsList.component.ts